import EfImg from 'elem/ui/ef-img';
import CountDown from '@/components/CountDown';
import PageLayout from '@/components/PageLayout';
import OldUserModal, { OldUserModalHandle } from '@/components/Referral/Common/OldUserModal';
import SEOlinksA from '@/components/SEOlinksA';
import Button from '@/components/UI/Button';
import Checkbox from '@/components/UI/Checkbox';
import Input from '@/components/UI/Input';
import { EFAkIn, EFAkout } from '@/components/UI/svg/My';
import { ENGLISH_LANG, i18nMap, newVersionRegion, rpcMap } from '@/constants';
import { loginImageMap } from '@/constants/login';
import seoconfig from '@/seoconfig/register';
import { checkAccountIsExist, checkHumanMachine, createSubscribe, createSubscribeCommunity, getVerifyCode, toRegister, toRegisterNew } from '@/service';
import { redirectTo404 } from '@/utils';
import { onLogin } from '@/utils/cookie';
import { getKaamelPlan } from '@/utils/kaamelTest';
import { setLocalStorage } from '@/utils/localStorage';
import { langeMap } from '@/utils/locals';
import { useGlobal } from '@/utils/useGlobal';
import { Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import debounce from 'lodash/debounce';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import css from './register.module.scss';
import { LOGIN_MAP, SUBSCRIBE_MAP, FORUM_APPID_MAP } from '@/constants/forum';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';
import { usePageBackground } from '@/utils/hooks/usePageBackground';
import EcoCreditDescription from '@/components/EcoCreditDescription';
import SocialLoginLinks from '@/components/SocailLoginLinks';
import { sendPostErrorMonitoring } from '@/appComps/ErrorMonitoringCommon/api';

const HOMEBATTERY_REDIRECT = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;

export default function Register({ redirect, prevPath, lang, SEO }: any) {
    if (redirect.split('redirect=')[1]) {
        redirect = redirect.split('redirect=')[1];
    }
    const recaptchaRef = React.useRef();
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
    const { useLang, Link, gtm } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('register');
    const [inputClass, SetInputClass] = useState({
        activeFirst: '',
        activeSecond: '',
        activeThird: '',
        name: '',
    });
    const [loading, setLoading] = useState(false);
    const [isShowTip, setIsShowTip] = useState(false);
    const [allValidate, setAllValidate] = useState({
        email: false,
        pwd: false,
        confirmPassword: false,
    });
    const [step, setStep] = useState({ first: true, second: false, third: false });
    const [emailValidating, setEmailValidating] = useState<any>(''); // 'success' 'warning' 'error' 'validating'
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [errorTip, setErrorTip] = useState('');
    const [isErrorTip, setIsErrorTip] = useState(false);
    const [kaamelInfo, setKaamelInfo] = useState<any>(null);
    const router = useRouter();
    const { locale = 'us', query } = router;
    const form = Form.useForm()[0];
    const emailCodeForm = Form.useForm()[0];
    const [emailCodeInputStatus, setEmailCodeInputStatus] = useState(0);
    const [resendCode, setResendCode] = useState(60);
    const [formData, setFormData] = useState<Record<string, any>>({});
    const isNewVersionRegion = newVersionRegion(locale);
    const [humanCheck, setHumanCheck] = useState(false);
    const { _source } = query;

    const { backgroundImage, isLoaded, isAnimating, imageUrl } = usePageBackground(locale);

    const isSelected = ['us', 'ca', 'au', 'jp'].includes(locale);

    const toRegisterFunc = isNewVersionRegion ? toRegisterNew : toRegister;

    // const pwdRegx = isNewVersionRegion
    //     ? /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=.*[^0-9A-Za-z\f\n\r\t\v])(?=^[0-9A-Za-z\S]{15,32}$).*$/
    //     : /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;
    const pwdRegx = isNewVersionRegion
        ? /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?\/\\|-])\S{15,32}$/
        : /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;

    // 老用户使用邀请码时提示
    const oldUserRef = useRef<OldUserModalHandle>(null);
    const [email, setEmail] = useState('');
    const loginImageUrl = loginImageMap[locale as keyof typeof loginImageMap] || loginImageMap.us;
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];

    // 重定向：A页 => 注册页注册成功 => 登陆页登录成功 => 返回至来源A页 【许要求的】
    // 因为刷新页面prevPath会变null, 故改用?redirect重定向
    useEffect(() => {
        if (!redirect && prevPath) {
            if (prevPath.indexOf('?redirect=') > -1) {
                const paramRedirct = `?redirect=${prevPath.split('?redirect=')[1]}`;
                router.push(`/${locale}/register${paramRedirct}`);
            } else if (prevPath?.split('?')[0].endsWith(`/${locale}`)) {
                router.push(`/${locale}/register?redirect=/${locale}`);
            }
        }
    }, [redirect, prevPath]);

    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) return;
        setRecaptchaResponse(captchaCode);
        // form.validateFields(['recaptchaResponse']);
        form.setFields([
            {
                name: 'recaptchaResponse',
                value: captchaCode,
                errors: [],
            },
        ]);
    };

    // 分享注册后老用户提示
    const handleReferralModal = () => {
        const { inviteCode } = query;
        // 是分享页面过来注册的用户
        if (inviteCode) {
            oldUserRef.current?.show();
        }
    };

    // 校验邮箱
    const validateEmail = () => {
        return {
            validator: async (_: any, value: any) => {
                const regx = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                if (!value) {
                    setEmailValidating('error');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                    return Promise.reject(lang.site_login_tip_email_empty);
                }

                if (!regx.test(value)) {
                    setEmailValidating('error');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                    return Promise.reject(lang.site_login_tip_email_format_incorrect);
                }
                setEmailValidating('validating');
                try {
                    const res: any = await checkAccountIsExist({ email: value });

                    if (res.code === '0') {
                        setEmailValidating('error');
                        setAllValidate({
                            ...allValidate,
                            ...{ email: false },
                        });
                        handleReferralModal();
                        return Promise.reject(lang.site_login_tip_email_be_registered);
                    } else if (res.code === '1003') {
                        setAllValidate({
                            ...allValidate,
                            ...{ email: true },
                        });
                        setEmail(value);
                        setEmailValidating('success');
                    }
                    return Promise.resolve();
                } catch (err) {
                    setEmailValidating('');
                    setAllValidate({
                        ...allValidate,
                        ...{ email: false },
                    });
                }
            },
        };
    };

    // 校验密码
    const validatePassword = () => {
        return {
            validator(_: any, value: any) {
                if (!value) {
                    setAllValidate({
                        ...allValidate,
                        pwd: false,
                    });
                    return Promise.reject(t('logintips.site_login_tip_password_empty'));
                }
                if (!value || pwdRegx.test(value)) {
                    setAllValidate({
                        ...allValidate,
                        pwd: true,
                    });
                    return Promise.resolve();
                }
                setAllValidate({
                    ...allValidate,
                    pwd: false,
                });
                return Promise.reject(t('logintips.site_login_tip_password_format_wrong'));
            },
        };
    };

    // 校验确认密码
    const validateConfirmPassword = ({ getFieldValue }: any) => {
        return {
            validator(_: any, value: any) {
                const pwd = getFieldValue('password');
                setIsErrorTip(false);
                if (!value) {
                    setAllValidate({
                        ...allValidate,
                        confirmPassword: false,
                    });
                    return Promise.reject(lang.site_login_tip_password_empty);
                }
                if (value && !pwdRegx.test(value)) {
                    return Promise.reject(t('logintips.site_login_tip_password_format_wrong'));
                }
                if (pwd !== value) {
                    setAllValidate({
                        ...allValidate,
                        confirmPassword: false,
                    });
                    return Promise.reject(lang.site_login_tip_password_twice_inconsistent);
                }
                setAllValidate({
                    ...allValidate,
                    confirmPassword: true,
                });
                return Promise.resolve();
            },
        };
    };

    const handleFinish = async () => {
        // 处理旧注册场景
        const data = form.getFieldsValue();
        setFormData(data);

        gtm.push({
            event: 'uaEvent',
            event_name: 'click_sign_up',
            button_name: isNewVersionRegion ? lang.site_register_next : lang.site_register_submit,
            signup_type: 'registration with password',
            source_channel: 'Website',
            from_page: localStorage.getItem('from_page_login') || 'direct',
        });

        if (isNewVersionRegion) {
            // step 1 not need checkHumanMachine,因为已经传递了recaptchaResponse
            sendEmailCode();
            // handleBeforeSendCode();
        } else {
            await handleSubmit(data);
        }
    };

    // 提交
    const handleSubmit = async (form1Data?: any) => {
        const recaptchaRes = humanCheck ? { recaptchaResponse } : {};
        const { inviteCode } = query;

        const values = emailCodeForm.getFieldsValue();
        const { email, password, confirmPassword, remember, subscribe } = form1Data || formData;

        gtm.push({
            event: 'uaEvent',
            event_name: 'click_sign_up',
            button_name: 'register',
            signup_type: 'registration with password',
            source_channel: 'Website',
            from_page: localStorage.getItem('from_page_login') || 'direct',
        });

        const params: any = {
            source: LOGIN_MAP[_source as string] || 'ECOFLOW_WEB',
            email: email,
            userType: 'ECOFLOW', //用户类型
            scene: LOGIN_MAP[_source as string] || 'ECOFLOW_WEB', //登陆场景
            password: Base64.stringify(Utf8.parse(password)),
            confirmPassword: Base64.stringify(Utf8.parse(confirmPassword)),
            isAgree: remember,
            ...recaptchaRes,
        };

        // 家储官网注册用户
        if (redirect && redirect.includes(`${HOMEBATTERY_REDIRECT}`)) {
            params.efHomeBattery = true;
        }

        if (isNewVersionRegion) {
            Object.assign(params, { code: values.code });
        }
        if (inviteCode) {
            Object.assign(params, { inviteCode2: inviteCode });
        }

        setLoading(true);

        try {
            // 获取浏览器指纹
            // const fp = await FingerprintJS.load();
            // const { visitorId } = await fp.get();
            const { utm_source = '' } = query;
            if (utm_source && ['email', 'emarsys'].includes(String(utm_source)?.toLowerCase())) {
                params.entry_name = 'Email';
                params.page_url = window.location.href;
                params.source_channel = 'Website';
            }

            const res: any = await toRegisterFunc(params, '', locale, _source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY ? FORUM_APPID_MAP[locale] : '');
            const langLocal = langeMap[locale] || 'en_US';
            setLoading(false); // 关闭loading
            if (res.code === '0') {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'sign_up',
                    page_name: '/register',

                    entry_method: 'Page_registration with password',
                    entry_type: 'fixed entry',
                    entry_name: localStorage.getItem('from_page_login') || 'direct',
                    entry_position: 'none',
                    source_channel: 'Website',
                    signup_type: 'password',
                    from_page: localStorage.getItem('from_page_login') || 'direct',
                });
                setLocalStorage('rigisterFrom', query?.redirect === '/support/warranty' ? query?.redirect : '');
                const data = langLocal ? { lang: langLocal } : {};
                Object.assign(data, { email: email, scene: 'ACCOUNT_VERIFICATION' });
                // 如果是us站或者ca，直接订阅不需要勾选，其他站点则需要
                if (locale === 'us' || locale === 'ca' || subscribe) {
                    if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
                        await createSubscribeCommunity({ email: email, source: SUBSCRIBE_MAP[_source as string] }, locale);
                    } else {
                        await createSubscribe({
                            email: email,
                            source: 'WEB_REGISTER',
                            eventTracking: subscribeCookie({
                                entry_name: 'Create EcoFlow Account',
                            }),
                        });
                    }
                }
                if (isNewVersionRegion) {
                    setRecaptchaResponse('');
                    const rptRef: any = recaptchaRef?.current;
                    rptRef?.reset && rptRef?.reset();
                    setFormData({});
                }

                onLogin(res.data, false);
                setStep({ first: false, second: false, third: true });
            } else {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'sign_up_fail',
                    page_name: '/register',
                    entry_method: 'Page_registration with password',
                    entry_type: 'fixed entry',
                    entry_name: localStorage.getItem('from_page_login') || 'direct',
                    entry_position: 'none',
                    source_channel: 'Website',
                    signup_type: 'password',
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'login_fail',
                    page_name: '/login',
                });
                sendPostErrorMonitoring(locale, {
                    error_type_1: 'user-error',
                    error_type_2: 'register',
                    error_content_1: res.code,
                    error_content_2: res.message,
                });
                if (!isNewVersionRegion) {
                    setRecaptchaResponse('');
                    const rptRef: any = recaptchaRef?.current;
                    rptRef?.reset && rptRef?.reset();
                }
                setErrorTip(res.message || 'error');
                setIsErrorTip(true);
            }
        } catch (e) {
            console.log(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'sign_up_fail',
                page_name: '/register',
                entry_method: 'Page_registration with password',
                entry_type: 'fixed entry',
                entry_name: localStorage.getItem('from_page_login') || 'direct',
                entry_position: 'none',
                source_channel: 'Website',
                signup_type: 'password',
            });
            sendPostErrorMonitoring(locale, {
                error_type_1: 'user-error',
                error_type_2: 'register',
                error_content_1: `error:${e}`,
            });
            setErrorTip('error');
            setLoading(false); // 关闭loading
        }
    };

    const goLogin = () => {
        localStorage.setItem('from_page_login', 'Page_registration with password');
        gtm.push({
            event: 'uaEvent',
            event_name: 'login_register_switch',
            button_name: isNewVersionRegion ? lang.site_sign_instead : lang.site_login_login,
            signup_type: 'Page_login with password',
        });
        // let url = redirect ? redirect : `/${locale}/login`;
        // if (redirect) url += `?redirect=${encodeURIComponent(redirect)}`;

        let url = `/${locale}/login`;
        if (redirect) url += `?redirect=${encodeURIComponent(redirect)}`;

        if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
            if (!url.includes(_source as string)) {
                url += `&_source=${_source}`;
            }
        }
        signupCookie({
            entry_name: 'Create EcoFlow Account',
        });
        router.push(url);
    };

    const goRegister = () => {
        try {
            localStorage.setItem('from_page_login', 'Page_registration with password');
            gtm.push({
                event: 'uaEvent',
                event_name: 'login_register_switch',
                button_name: 'Register without password',
                signup_type: 'Page_registration with password',
            });
            const searchParams = new URLSearchParams(window.location.search);
            const queryString = searchParams.toString();
            const targetUrl = `/${locale}/register/passwordless${queryString ? `?${queryString}` : ''}`;
            signupCookie({ entry_name: 'Register without password' });

            router.push(targetUrl);
            // window.location.href = `/${locale}/register/passwordless${window.location.search}`;
        } catch (err) {}
    };

    const goAfterLogin = (btnName?: string) => {
        const url = redirect ? redirect : `/${locale}`;
        window.location.href = url;
        // router.push(url);
    };

    const backToWarranty = () => router.push(redirect);

    const onBlurInput = (event: any, value: any) => {
        if (value === 'pwd') {
            setIsShowTip(false);
        }
        if (!event.target.value) {
            if (value == 'email') {
                SetInputClass({
                    activeFirst: '',
                    activeSecond: inputClass.activeSecond,
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'pwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: '',
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'conpwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: inputClass.activeSecond,
                    activeThird: '',
                    name: value,
                });
            }
        }
    };

    const onFocusInput = (event: any, value: any) => {
        if (value === 'pwd') {
            const [infos] = form.getFieldsError(['password']);
            const { errors } = infos;

            if (!errors.length) {
                setIsShowTip(true);
            }
        }
        if (!event.target.value) {
            if (value == 'email') {
                SetInputClass({
                    activeFirst: 'active',
                    activeSecond: inputClass.activeSecond,
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'pwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: 'active',
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'conpwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: inputClass.activeSecond,
                    activeThird: 'active',
                    name: value,
                });
            }
        }
    };

    // 发送邮件验证码
    const sendEmailCode = async () => {
        const account = form.getFieldValue('email');
        // const recaptchaRes = humanCheck ? { recaptchaResponse } : {};

        let recaptchaRes = {};
        // register step 1 need recaptcha
        if (step.first) {
            recaptchaRes = { recaptchaResponse };
        }

        // register step 2 need recaptcha if humanCheck is true
        if (step.second) {
            recaptchaRes = humanCheck ? { recaptchaResponse } : {};
        }

        const obj = { scene: 'WEBSITE_REGISTER_VERIFICATION_CODE', account, ...recaptchaRes };
        setLoading(true);
        try {
            const res: any = await getVerifyCode(obj, locale);
            setLoading(false);
            if (res.code === '0') {
                setStep({ first: false, second: true, third: false });
                // step 1 not need HumanCheck
                !!step.second && setHumanCheck(false);
            } else if (res.code === '2017') {
                // step 1 not need HumanCheck
                // step 1 已经传了 recaptchaResponse, 正常情况下不会返回 2017 code
                !!step.second && setHumanCheck(true);
                setIsErrorTip(true);
                setErrorTip(res.message);
            } else {
                setIsErrorTip(true);
                setErrorTip(res.message);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const handleBeforeSendCode = async () => {
        if (humanCheck && recaptchaResponse) {
            sendEmailCode();
            return;
        }
        const params = {
            functionName: 'register',
            account: email,
        };
        setLoading(true);
        try {
            const res = await checkHumanMachine(params);
            setLoading(false);
            if (res.code === '0') {
                setHumanCheck(res.data);
                if (!res.data) {
                    sendEmailCode();
                }
            } else {
                setErrorTip(res.message);
                setIsErrorTip(true);
            }
            return;
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        // 埋点，协议勾选
        if (['us', 'ca', 'au', 'jp'].includes(locale)) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'register_privacy_agree',
                tag: true,
            });
        }
    }, [locale]);

    useEffect(() => {
        const info = getKaamelPlan();
        setKaamelInfo(info);
    }, []);

    return (
        <PageLayout className={css.registerPageLayout}>
            <div
                className={`${css.fullscreenBackground} ${isLoaded ? css.loaded : ''} ${isAnimating ? css.fadeIn : ''}`}
                style={
                    {
                        '--bg-image': backgroundImage ? `url(${backgroundImage})` : 'none',
                    } as React.CSSProperties & { '--bg-image': string }
                }
            />
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <div className={`${css.register} container login_page_a`}>
                <div className="login-box">
                    {/* <div className="left">
                        <Image src={loginImageUrl} width={509} height={850} alt={lang.site_register_register}></Image>
                    </div> */}
                    <div className={`right ${step.third ? 'third-right' : ''}`}>
                        {step.first && (
                            <div className="register-box">
                                <h1>{lang.site_register_register}</h1>
                                <Form name="normal_login" className="login-form" form={form} initialValues={{ remember: isSelected }} onFinish={handleFinish}>
                                    <div className="inputItem">
                                        <label className={inputClass.activeFirst == 'active' ? 'active' : ''}>{lang.site_login_email}</label>
                                        <Form.Item name="email" shouldUpdate validateStatus={emailValidating} rules={[validateEmail]} validateTrigger="onBlur">
                                            <Input
                                                className="default-input "
                                                autoComplete="off"
                                                aria-label={lang.site_login_email}
                                                onFocus={(e: any) => onFocusInput(e, 'email')}
                                                onBlur={(e: any) => onBlurInput(e, 'email')}
                                                onChange={debounce(() => {
                                                    if (!inputClass.activeFirst) {
                                                        SetInputClass({
                                                            activeFirst: 'active',
                                                            activeSecond: inputClass.activeSecond,
                                                            activeThird: inputClass.activeThird,
                                                            name: 'email',
                                                        });
                                                        form.validateFields(['Email']);
                                                    }
                                                }, 300)}
                                            />
                                        </Form.Item>
                                    </div>

                                    <div className="inputItem">
                                        <label className={inputClass.activeSecond == 'active' ? 'active' : ''}>{lang.site_login_password}</label>
                                        <Form.Item name="password" rules={[validatePassword]} validateTrigger="onBlur">
                                            <Input.Password
                                                type="password"
                                                shouldUpdate
                                                className="default-input"
                                                autoComplete="new-password"
                                                aria-label={lang.site_login_password}
                                                iconRender={(visible: boolean) => <div>{visible ? <EFAkIn className={'iconfont'} /> : <EFAkout />}</div>}
                                                onFocus={(e: any) => onFocusInput(e, 'pwd')}
                                                onBlur={(e: any) => onBlurInput(e, 'pwd')}
                                            />
                                        </Form.Item>
                                        {isShowTip && (
                                            <div className="password-tip">
                                                <div className="header-line">
                                                    <span>Example</span>
                                                    <span>Chage123#4</span>
                                                </div>
                                                <div className="password-tip-content">{t('logintips.site_login_tip_password_format_wrong')}</div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="inputItem">
                                        <label className={inputClass.activeThird == 'active' ? 'active' : ''}>{lang.site_register_enter_password_again}</label>
                                        <Form.Item
                                            name="confirmPassword"
                                            shouldUpdate
                                            dependencies={['password']}
                                            rules={[validateConfirmPassword]}
                                            validateTrigger="onBlur"
                                        >
                                            <Input.Password
                                                type="password"
                                                className="default-input"
                                                autoComplete="new-password"
                                                aria-label={lang.site_register_enter_password_again}
                                                iconRender={(visible: boolean) => <div>{visible ? <EFAkIn className={'iconfont'} /> : <EFAkout />}</div>}
                                                onFocus={(e: any) => onFocusInput(e, 'conpwd')}
                                                onBlur={(e: any) => onBlurInput(e, 'conpwd')}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="inputItem">
                                        <Form.Item
                                            name="recaptchaResponse"
                                            rules={[
                                                {
                                                    validator() {
                                                        if (recaptchaResponse) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                    },
                                                },
                                            ]}
                                            style={{ marginBottom: '16px', marginTop: '16px' }}
                                        >
                                            <div className="g-recaptcha">
                                                {/* @ts-ignore */}
                                                <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                            </div>
                                        </Form.Item>
                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>
                                    {locale !== 'us' && locale !== 'ca' && (
                                        <Form.Item name="subscribe" valuePropName="checked" noStyle>
                                            <Checkbox className="agreement subscribe">{lang.site_register_agree_subscribe}</Checkbox>
                                        </Form.Item>
                                    )}
                                    <Form.Item style={{ marginBottom: '16px' }}>
                                        <Form.Item
                                            name="remember"
                                            valuePropName="checked"
                                            rules={[
                                                {
                                                    validator: (_, value) =>
                                                        value ? Promise.resolve() : Promise.reject(lang.site_login_tip_agree_user_agreement),
                                                },
                                            ]}
                                            noStyle
                                        >
                                            <Checkbox
                                                className="agreement"
                                                onChange={(e: CheckboxChangeEvent) => {
                                                    // Agree/Disagree/None
                                                    const isAgreed = e?.target?.checked ? 'Agree' : 'Disagree';
                                                    gtm.push({
                                                        event: 'uaEvent',
                                                        event_name: 'register_privacy_agree',
                                                        tag: isAgreed,
                                                    });
                                                }}
                                            >
                                                <span className="checkbox-msg">
                                                    {s.rich('site_login_tip_agree_user_agreement1', {
                                                        link1: (children: any) => (
                                                            <Link
                                                                href={
                                                                    locale === 'cis'
                                                                        ? 'https://account.ecoflow.com/agreement/ru-cis/PrivacyPolicy.html'
                                                                        : locale === 'uk' && kaamelInfo?.privacyUrl
                                                                        ? kaamelInfo?.privacyUrl
                                                                        : `https://account.ecoflow.com/agreement/${
                                                                              i18nMap[locale] || i18nMap.us
                                                                          }/PrivacyPolicy.html`
                                                                }
                                                                newWin
                                                                ariaLabel={s('privacy')}
                                                            >
                                                                {children}
                                                            </Link>
                                                        ),
                                                        link2: (children: any) => (
                                                            <Link
                                                                href={
                                                                    locale === 'cis'
                                                                        ? 'https://account.ecoflow.com/agreement/ru-cis/TermsOfUse.html'
                                                                        : `https://account.ecoflow.com/agreement/${
                                                                              i18nMap[locale] || i18nMap.us
                                                                          }/TermsOfUse.html`
                                                                }
                                                                newWin
                                                                ariaLabel={s('TOU')}
                                                            >
                                                                {children}
                                                            </Link>
                                                        ),
                                                    })}
                                                </span>
                                            </Checkbox>
                                        </Form.Item>
                                    </Form.Item>
                                    <EcoCreditDescription
                                        title={lang.ecocredit_title}
                                        word1={lang.ecocredit_word1}
                                        word2={lang.ecocredit_word2}
                                        word3={lang.ecocredit_word3}
                                        alternativeWord1={lang.ecocredit_word1_1}
                                    />
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="register-form-submit"
                                        loading={loading}
                                        aria-label={lang.site_register_submit}
                                        disabled={!(allValidate.email && allValidate.pwd && allValidate.confirmPassword)}
                                    >
                                        {isNewVersionRegion ? lang.site_register_next : lang.site_register_submit}
                                    </Button>
                                    <div className="navigate-content">
                                        <Button type="link" className="other-button" onClick={() => goLogin()} aria-label={lang.site_login_login}>
                                            {isNewVersionRegion ? lang.site_sign_instead : lang.site_login_login}
                                        </Button>
                                        <Button type="link" className="other-button" onClick={() => goRegister()} aria-label={lang.site_login_login}>
                                            {lang.register_btn_text}
                                        </Button>
                                    </div>
                                    <div className="divider-line">{`- ${lang.site_login_or || ''} -`}</div>
                                    <SocialLoginLinks redirectUrl={redirect} showLineLogin={locale === 'jp'} />
                                </Form>
                            </div>
                        )}
                        {step.second && (
                            <div className="register-box box-center second-box">
                                <h1 className="second-title">{lang.site_register_second_title}</h1>
                                <div className="second-desc">
                                    {s.rich('site_register_second_desc', {
                                        a: () => (
                                            <a style={{ color: '#3370ff', textDecoration: 'underline' }} href={`mailto:${formData.email}`}>
                                                {formData.email}
                                            </a>
                                        ),
                                        b: (text: string) => <span style={{ fontFamily: 'var(--font-family-Bold)' }}>{text}</span>,
                                    })}
                                </div>
                                <Form name="code_form" className="login-form" form={emailCodeForm} initialValues={{ remember: false }}>
                                    <div className="inputItem">
                                        <label className={emailCodeInputStatus !== 0 ? 'active' : ''}>{lang.site_register_enter_code}</label>
                                        <Form.Item name="code" shouldUpdate>
                                            <Input
                                                className="default-input "
                                                autoComplete="off"
                                                aria-label={lang.site_register_enter_code}
                                                maxLength={6}
                                                disabled={loading}
                                                onFocus={(e: any) => {
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 1);
                                                }}
                                                onBlur={(e: any) => {
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 0);
                                                }}
                                                onChange={debounce((e) => {
                                                    setErrorTip('');
                                                    setIsErrorTip(false);
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 1);
                                                    if (val.length === 6) {
                                                        handleSubmit();
                                                    }
                                                }, 300)}
                                            />
                                        </Form.Item>
                                        <div className="error-tip">{errorTip}</div>
                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>
                                    {humanCheck && isNewVersionRegion && (
                                        <Form.Item
                                            name="recaptchaResponse"
                                            rules={[
                                                {
                                                    validator() {
                                                        if (recaptchaResponse) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                    },
                                                },
                                            ]}
                                            style={{ marginBottom: '32px', marginTop: '12px' }}
                                        >
                                            <div className="g-recaptcha">
                                                {/* @ts-ignore */}
                                                <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                            </div>
                                        </Form.Item>
                                    )}
                                    {/* <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="black-btn large register-form-submit"
                                            loading={loading}
                                            aria-label={lang.site_register_submit}
                                            disabled={emailCodeInputStatus !== 2}
                                        >
                                            {lang.site_register_submit}
                                        </Button>
                                    </Form.Item> */}
                                </Form>
                                <Button
                                    type="link"
                                    disabled={resendCode !== 0}
                                    className="resend-code"
                                    onClick={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'resend_verification_coder',
                                            button_name: lang.site_resend_code,
                                        });
                                        handleBeforeSendCode();
                                        setResendCode(60);
                                    }}
                                >
                                    {lang.site_resend_code}
                                    <CountDown
                                        sec={resendCode}
                                        secUnit={t('secondUnit')}
                                        onFinish={() => {
                                            setResendCode(0);
                                        }}
                                    />
                                </Button>
                            </div>
                        )}
                        {step.third && (
                            <div className="register-box box-center">
                                <p>{lang.site_register_successful}</p>
                                <Button
                                    type="primary"
                                    className="black-btn large login-redirect-button"
                                    aria-label={lang.site_register_got_it}
                                    onClick={() => {
                                        redirect.indexOf('/support/warranty') > -1 ? backToWarranty() : goAfterLogin(lang.site_register_got_it);
                                        if (redirect.indexOf('/support/warranty') > -1) {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'click_login',
                                                button_name: lang.site_register_got_it || 'login',
                                                source_channel: 'Website',
                                                from_page: 'registration with password',
                                            });
                                        }
                                    }}
                                >
                                    {lang.site_register_got_it}
                                </Button>
                                <div className="redirect-tip-box">
                                    {s.rich('redirect_tip', {
                                        highLight: (text: string) => (
                                            <span>
                                                {text}
                                                <CountDown
                                                    sec={3}
                                                    isNeedBracket={false}
                                                    secUnit=""
                                                    onFinish={() => {
                                                        redirect.indexOf('/support/warranty') > -1 ? backToWarranty() : goAfterLogin();
                                                    }}
                                                />
                                            </span>
                                        ),
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <OldUserModal ref={oldUserRef} />
        </PageLayout>
    );
}

export async function getServerSideProps(context: any) {
    const prevPath = context.req.headers.referer;
    const { redirect } = context.query;
    const { locale } = context;
    if (['cn', 'nl'].includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {
            redirect: redirect || '',
            prevPath: prevPath || '',
        },
    };
}
